<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" sm="12">
        <AppSectionHero :section-number="sectionNumber">
          <template v-slot:main-title>{{
            $t("content.sections.who.title.lead")
          }}</template>
          <template v-slot:title>{{
            $t("content.sections.who.title.body")
          }}</template>
        </AppSectionHero>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" sm="12" class="pt-0">
        <i18n tag="p" path="content.sections.who.intro">
          <span slot="count" class="primary--text font-weight-black">{{
            filteredCount
          }}</span>
        </i18n>

        <v-row>
          <v-col
            v-for="filter in nonRegionFilters"
            :key="filter"
            cols="12"
            sm="6"
            lg="6"
          >
            <BarChartDemographic :filter="filter" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="6" sm="12">
        <h3 v-if="mapLikelyhood">
          {{ $t("content.sections.who.mapTitle.2") }}
        </h3>
        <h3 v-else>
          {{ $t("content.sections.who.mapTitle.1") }}
        </h3>
        <MapDemographic :show-likelyhood="mapLikelyhood" />
        <v-switch
          v-model="mapLikelyhood"
          label="View probability of experiencing a legal problem in each region"
          color="primary"
          hide-details
          class="mt-2 mb-5"
        >
        </v-switch>
        <AppTableHidden
          :table-headers="tableHeaders"
          :table-data="tableData"
          sorted-column="rwlp"
          :sectionNumber="sectionNumber"
        >
          <template v-slot:table-title>{{
            $t("content.sections.who.infoTable.title")
          }}</template>
          <template v-slot:card-info>
            <i18n tag="div" path="content.sections.who.infoTable.infoText">
              <span
                slot="RegionCount"
                class="section1--text font-weight-black"
                >{{ tableData[0].name }}</span
              >

              <span
                slot="RegionProbability"
                class="section1--text font-weight-black"
                >{{ mostProbabilyRegion[0].name }}</span
              >
            </i18n>
          </template>
        </AppTableHidden>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AppSectionHero from "@/components/AppSectionHero.vue";
import BarChartDemographic from "@/components/BarChartDemographic.vue";
import MapDemographic from "@/components/MapDemographic.vue";
import AppTableHidden from "@/components/AppTableHidden.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    AppSectionHero,
    BarChartDemographic,
    MapDemographic,
    AppTableHidden
  },
  props: {
    sectionNumber: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      mapLikelyhood: false,
      tableHeaders: [
        {
          text: this.$t("content.sections.who.infoTable.columnRegion"),
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: this.$t(
            "content.sections.who.infoTable.columnRespondentsNumber"
          ),
          value: "rwlp"
        },
        {
          text: this.$t(
            "content.sections.who.infoTable.columnRespondentsPercent"
          ),
          value: "percentOfPeople"
        }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "demographicsFilters",
      "filteredCount",
      "filteredDemographicData",
      "filteredDataNoLP"
    ]),
    nonRegionFilters() {
      return this.demographicsFilters.filter(d => d !== "region");
    },
    getRegionData() {
      return this.filteredDemographicData("region");
    },
    getThoseInRegionsWithNoLP() {
      return _.countBy(this.filteredDataNoLP.map(value => value["region"]));
    },
    tableData() {
      const formattedRegions = [];
      this.getRegionData.forEach(d => {
        const value = d.value ? d.value / this.filteredCount : 0;
        if (value != 0) {
          formattedRegions.push({
            key: d.key,
            name: this.$t(`filters.demographics.region.options.${d.key}`),
            rwlp: d.value,
            percentOfPeople: (
              (d.value / (d.value + this.getThoseInRegionsWithNoLP[d.key])) *
              100
            ).toFixed(1)
          });
        }
        formattedRegions.sort((a, b) => (a.rwlp < b.rwlp ? 1 : -1));
      });
      return formattedRegions;
    },
    mostProbabilyRegion() {
      return this.tableData.sort((a, b) =>
        a.percentOfPeople < b.percentOfPeople ? 1 : -1
      );
    }
  }
};
</script>